// /src/site/Components/banner.jsx
import React from "react";
import { Link } from 'react-router-dom'; // Importar
import './banner.css';

function Banner() {
    return (
        <section id="banner">
            <div className="container">
                <div className="row align-items-center"> {/* Alinha verticalmente */}
                    <div className="col-lg-6">
                        <h1 className="display-4">Venda mais e gerencie melhor com o R6 ERP.</h1>
                        <h4>A plataforma completa para impulsionar suas vendas no atacado. Gerencie clientes, pedidos e financeiro em um único lugar.</h4>
                        {/* Usa Link para rotas internas da aplicação */}
                        <div className="d-flex gap-3">
                            <Link to="/app/novaconta" className="btn btn-primary btn-lg bnt-banner btn-primary-custom">Criar conta grátis</Link>
                            <Link to="/app" className="btn btn-outline-dark btn-lg bnt-banner">Fazer login</Link>
                        </div>
                    </div>
                    <div className="col-lg-6 text-center"> {/* Centraliza a imagem */}
                        <div className="banner-img-container">
                            <img src="imagens/img_site.png" className="img-fluid" alt="Dashboard do sistema R6 ERP mostrando gráficos e vendas" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default Banner;